import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CreateTopicDialog = ({
  headerText,
  messageText,
  onSave,
  onClose
}) => {
  const [phrase, setPhrase] = useState('');
  const handleChange = event => {
    setPhrase(event.target.value.trim());
  };
  const isValid = phrase !== '';
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs(Modal, {
      "data-test-id": "topic-editor-create-topic-modal",
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onClose
        }), /*#__PURE__*/_jsx(H2, {
          children: headerText
        })]
      }), /*#__PURE__*/_jsxs(DialogBody, {
        children: [messageText, /*#__PURE__*/_jsx(FormControl, {
          label: headerText,
          children: /*#__PURE__*/_jsx(TextInput, {
            placeholder: I18n.text('xray-recommendation-lib.seo.topicEditor.createTopicModal.placeholder'),
            onChange: handleChange
          })
        })]
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(Button, {
          disabled: !isValid,
          use: "primary",
          onClick: () => onSave({
            phrase
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "xray-recommendation-lib.seo.topicEditor.createTopicModal.actions.save"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "xray-recommendation-lib.seo.topicEditor.createTopicModal.actions.close"
          })
        })]
      })]
    })
  });
};